import { render, staticRenderFns } from "./EmailRecipientsDialog.vue?vue&type=template&id=3976d0bc&scoped=true&"
import script from "./EmailRecipientsDialog.vue?vue&type=script&lang=js&"
export * from "./EmailRecipientsDialog.vue?vue&type=script&lang=js&"
import style0 from "./EmailRecipientsDialog.vue?vue&type=style&index=0&id=3976d0bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3976d0bc",
  null
  
)

export default component.exports